/**
 * Contacts search with no match (Robert, 2026-11-02, the "Both" directions of
 * ~/dev/scratch/mockups/vrs/vrs-contacts-add-1.html, for all Contacts views in
 * all apps): a search that finds no contact shows one first row, Add "<text>",
 * and the Add form opens with that text. A number also gets a row that calls
 * it, where the view can place that call.
 *
 * One rule for the web portal (script tag, window.MalkaContactSearchAdd) and
 * the web React views (import). The phone apps hold the same rule in
 * contactsScreenUtils.ts (contactSearchAddText, contactEntryKind).
 */
(function(root, factory) {
    const searchAdd = factory();
    if (typeof module === 'object' && module.exports) module.exports = searchAdd;
    else root.MalkaContactSearchAdd = searchAdd;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
    /**
     * The text for the Add row, or '' for no row. No row for an empty search,
     * a search that finds a contact, a list that is not the saved contacts
     * (the trash, a directory search), or a list that is loading or did not
     * load (a "no match" is then not real).
     *
     * @param {string} search - The search text.
     * @param {{ listReady: boolean, matches: number, trash: boolean }} list - The list state.
     * @returns {string}
     */
    function contactSearchAddText(search, list) {
        const text = typeof search === 'string' ? search.trim() : '';
        const { listReady, matches, trash } = list || {};

        return text && matches === 0 && listReady === true && !trash ? text : '';
    }

    /**
     * What the text is: 'handle' (@name), 'email', 'phone', 'name', or 'empty'.
     * The same rule as contactEntryKind in the phone apps.
     *
     * @param {string} value - The text.
     * @returns {'empty' | 'handle' | 'email' | 'phone' | 'name'}
     */
    function contactSearchAddKind(value) {
        const text = typeof value === 'string' ? value.trim() : '';

        if (!text) return 'empty';
        if (text.startsWith('@')) return 'handle';
        if (/^[^\s@]+@[^\s@]+$/.test(text)) return 'email';
        if (/^\+?[\d\s().-]+$/.test(text) && /\d/.test(text)) return 'phone';

        return 'name';
    }

    return { contactSearchAddKind, contactSearchAddText };
});
